import Modal from "components/DesignSystem/Modal/Modal";
import { Stepper } from "components/DesignSystem/Stepper/Stepper";
import { ArrowRight } from "components/icons/ArrowRight";
import { STEPS, STEPS_BREADCRUMBS } from "constants/qboImportSteps";
import { useImportFinally } from "./ImportFinallyContext";

const STEP_ORDER = Object.values(STEPS);

const ImportFinallyStepper = () => {
  const { currentStep, onStepChange } = useImportFinally();

  const currentStepIndex = STEP_ORDER.indexOf(currentStep);

  const steps = STEPS_BREADCRUMBS.map((breadcrumb) => {
    const stepIndex = STEP_ORDER.indexOf(breadcrumb.step);

    return {
      ...breadcrumb,
      isActive: currentStepIndex >= stepIndex,
      isClickable: currentStepIndex > stepIndex,
      isLast: breadcrumb.step === STEPS.REVIEW,
    };
  });

  return (
    <Stepper size="xs" direction="horizontal" className="!t-gap-0">
      {steps.map(({ name, step, no, isActive, isClickable, isLast }) => (
        <Stepper.Step
          key={step}
          step={no}
          isActive={isActive}
          clickable={isClickable}
          onClick={() => onStepChange(step)}
        >
          <div className="t-flex t-items-center">
            {name}
            {!isLast && <ArrowRight color="currentColor" />}
          </div>
        </Stepper.Step>
      ))}
    </Stepper>
  );
};

export const ImportFinallyHeader = () => (
  <Modal.Header>
    <div className="t-flex t-flex-col t-gap-2">
      <Modal.Title>Import data from Finally</Modal.Title>
      <ImportFinallyStepper />
    </div>
    <Modal.Close />
  </Modal.Header>
);
